// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { navy } from '@zocdoc/branding/colors';

// Icon code
import { Icon } from './_base';

const CheckInSVG = styled(Icon).attrs({ viewBox: '0 0 43 40' })`
    width: 1.075em;
`;

const CheckIn = ({ color = navy, ...props }) => (
    <CheckInSVG data-test="icon-check-in" {...props}>
        <path
            d="M26.41,40H0.33V5.17H17.74v4.2H4.53V35.8H22.21V31.34h4.2V40Zm-7.86-8.75H9.08v-9.6L33.13,0l9.54,9.54ZM13.28,27h3.66L36.57,9.38,33,5.79,13.28,23.52V27Z"
            fill={color}
        />
    </CheckInSVG>
);

export { CheckIn as default, CheckIn };
